import { render } from "./ThinkTanksByEntityChart.vue?vue&type=template&id=53ae009f"
import script from "./ThinkTanksByEntityChart.vue?vue&type=script&lang=js"
export * from "./ThinkTanksByEntityChart.vue?vue&type=script&lang=js"
script.render = render

export default script